import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeIframe',
  props: {
    videoId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Lumiform Demo Video',
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})